// Stored in a cookie (not the account) so page.jsx can read it server-side and
// render the right UI on first paint without a flash. Browser-scoped like a
// theme, so it survives logout. Transitional: remove once the new UI is fully
// rolled out (along with the Settings toggle and the legacy branch in Create.jsx).

import Cookies from 'js-cookie'

export const GENERATE_UI_COOKIE = 'pc_generate_ui'
export const LEGACY_VALUE = 'legacy'
const COOKIE_EXPIRY_DAYS = 365

export function readLegacyGenerateUi() {
  if (typeof document === 'undefined') return false
  return Cookies.get(GENERATE_UI_COOKIE) === LEGACY_VALUE
}

export function setLegacyGenerateUi(legacy) {
  if (legacy) {
    Cookies.set(GENERATE_UI_COOKIE, LEGACY_VALUE, {
      expires: COOKIE_EXPIRY_DAYS,
      path: '/',
    })
  } else {
    Cookies.remove(GENERATE_UI_COOKIE, { path: '/' })
  }
  return legacy
}
